/**
 * @file 首页
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {
    GET_PAGES_DETAIL
} from './ActionTypes';

export function fetchGetDetail(dispatch, params) {
    return rcAjax('POST', '/api/v1/pages/getDetail', {}, params, data => {
        dispatch({type: GET_PAGES_DETAIL, data: data.data});
    });
}